import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState, useLayoutEffect, } from 'react';
import MessageGroup from '../../../molecules/timeline/MessageGroup';
import Divider from '../../../atoms/timeline/Divider';
import Message from '../../../atoms/timeline/Message';
import styled from 'styled-components';
import Phase from '../../../atoms/Phase';
import collect from 'collect.js';
import { uniqueId } from 'lodash';
import { scrollYPercentage } from '../../../../helpers/scrollYPercentage';
import MessageAction from '../../../atoms/timeline/MessageAction';
const _Container = styled.div `
    padding-top: 1rem;
    padding-bottom: 1rem;
    width: 100%;
`;
const ActionsContainer = styled.div `
    display: flex;
    flex-direction: column;
    margin-left: auto;
    padding-left: 0.5rem;
    white-space: nowrap;

    & > *:not(:last-child) {
        margin-bottom: 1rem;
    }
`;
const Messages = ({ onScroll, history, filters = [] }) => {
    const [percentage, setPercentage] = useState(0);
    const filteredHistory = useMemo(() => {
        const newHistory = [...history];
        newHistory.forEach((phase, index) => {
            const newPhase = { ...phase };
            newPhase.lines = phase.lines.filter(item => {
                if (filters.length === 0)
                    return true;
                return filters.includes(item.type);
            });
            newHistory[index] = newPhase;
        });
        return newHistory.filter(phase => phase.lines.length > 0);
    }, [filters]);
    const lines = useMemo(() => filteredHistory.reduce((acc, val) => acc.concat(val.lines), []), [filteredHistory]);
    useEffect(() => {
        const maxIndex = (lines.length - 1) * (percentage / 100);
        const line = lines[Math.floor(maxIndex)];
        if (line)
            onScroll(line.date);
    }, [lines, percentage]);
    const handleScroll = () => {
        setPercentage(scrollYPercentage());
    };
    useLayoutEffect(() => {
        if (typeof window !== 'undefined')
            window.addEventListener('scroll', handleScroll);
        return () => {
            if (typeof window !== 'undefined')
                window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);
    return (_jsx(_Container, { children: filteredHistory.map((phase, index) => (_jsxs(React.Fragment, { children: [_jsx(Phase, { type: "next", children: phase.phase_name }), collect(phase.lines)
                    .groupBy('date')
                    .map((lines, date) => {
                    return (_jsx(MessageGroup, { date: new Date(date).toLocaleDateString('nl-nl', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                        }), children: lines.map(line => (_jsxs(Message, { type: line.type, children: [line.message, line?.actions?.length > 0 && (_jsx(ActionsContainer, { children: line.actions.map(action => (_jsx(MessageAction, { action: action }, action.label))) }))] }, uniqueId(line.type)))) }, uniqueId(date)));
                })
                    .toArray(), _jsx(Phase, { type: "previous", children: phase.phase_name }), ' ', index !== filteredHistory.length - 1 && _jsx(Divider, {})] }, uniqueId(phase.phase_name)))) }));
};
export default Messages;
